import { FC } from 'react';
import { SweepViewModalProps } from './sweepViewModal.type';
import './sweepViewModal.css';
import CloseIcon from '../../assets/close.png';
import ActionButton from '../button/button';
import { Trans } from 'react-i18next';
import Download from '../../assets/download.png';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import Loading from '../../assets/loading/loading';
import { getIdAttributes } from '../../utils/helper';
export const idPrefix: string = 'sweepViewModal';

const SweepViewModal: FC<SweepViewModalProps> = (props) => {
  const { isTablet } = useResponsiveLayout();

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[2000] ${props.modalOverlayClass}`}
      {...getIdAttributes(idPrefix, 'overlay')}
    >
      {isTablet ? (
        <>
          <div className={`absolute top-7 right-6 flex gap-3 z-[30]`}>
            <ActionButton
              onClick={props.onClose}
              className="h-9 w-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 border border-gray-300"
              {...getIdAttributes(idPrefix, 'closeButton')}
            >
              <img src={CloseIcon} alt="Close" className="w-4 h-4" />
            </ActionButton>
          </div>
          <div
            className={`absolute bottom-0 flex items-center justify-center bg-white w-[100vw] gap-3 z-[30] h-[100px] py-6 px-10`}
          >
            {props.onEdit && (
              <ActionButton
                onClick={props.onEdit}
                className="px-8 py-3 w-[50%] text-lg rounded-full bg-THEME_COLOR text-white hover:bg-THEME_COLOR"
                {...getIdAttributes(idPrefix, 'editButton')}
              >
                <Trans i18nKey="userManagement.edit" />
              </ActionButton>
            )}
            <ActionButton
              onClick={props.onDownload}
              className="px-4 py-3 w-[30%] text-lg rounded-full bg-white hover:text-black text-black border border-gray-500 hover:bg-gray-200 flex items-center justify-center gap-2"
              {...getIdAttributes(idPrefix, 'downloadButton')}
            >
              <img
                src={Download}
                alt="Close"
                className="w-4 h-4 cursor-pointer"
              />
              {props.showDownloadLoading ? (
                <Loading height={20} width={20} />
              ) : (
                <Trans i18nKey="sweeps.actionButton.download" />
              )}
            </ActionButton>
          </div>
        </>
      ) : (
        <div className={`absolute top-7 right-6 flex gap-3 z-[30]`}>
          {props.onEdit && (
            <ActionButton
              onClick={props.onEdit}
              className="px-8 py-1 text-sm rounded-full bg-THEME_COLOR text-white hover:bg-THEME_COLOR"
              {...getIdAttributes(idPrefix, 'editButton')}
            >
              <Trans i18nKey="userManagement.edit" />
            </ActionButton>
          )}
          <ActionButton
            onClick={props.onDownload}
            className="px-4 py-1 text-sm rounded-full bg-gray-100 hover:text-black text-black border border-gray-300 hover:bg-gray-200 flex items-center gap-2"
            {...getIdAttributes(idPrefix, 'downloadButton')}
          >
            <img
              src={Download}
              alt="Close"
              className="w-4 h-4 cursor-pointer"
            />
            {props.showDownloadLoading ? (
              <Loading height={20} width={20} />
            ) : (
              <Trans i18nKey="sweeps.actionButton.download" />
            )}
          </ActionButton>
          <ActionButton
            onClick={props.onClose}
            className="h-9 w-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 border border-gray-300"
            {...getIdAttributes(idPrefix, 'closeButton')}
          >
            <img src={CloseIcon} alt="Close" className="w-4 h-4" />
          </ActionButton>
        </div>
      )}

      <div className="flex flex-col items-center">
        <div
          className={`bg-white w-[46vw] h-[calc(100vh-60px)] overflow-auto relative shadow-md scrollbar-hide  ${
            isTablet && 'tabletModal'
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={'p-6'} {...getIdAttributes(idPrefix, 'content')}>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SweepViewModal;
